import { render, staticRenderFns } from "./AdditionalCourseContent.vue?vue&type=template&id=073ce84a&"
import script from "./AdditionalCourseContent.vue?vue&type=script&lang=js&"
export * from "./AdditionalCourseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports